import "./HomeAdditions.module.css";
import Header from "@/reusable_sections/Header";
import HomeAdditionsHero from "./sections/HomeAdditionsHero";
import AdditionsGuide from "./sections/AdditionsGuide";
import AdditionFaq from "./sections/AdditionFaq";
import EstimateLinks from "./sections/EstimateLinks";
import Footer from "@/reusable_sections/Footer";
export default function HomeAdditionsPage() {
  return <div>
      <Header />
      <HomeAdditionsHero />
      <AdditionsGuide />
      <AdditionFaq />
      <EstimateLinks />
      <Footer />
    </div>;
}